import { frontendNumber } from "utils/frontendNumber"

export const ColoredNumber = (number: number) => {
  return (
    <div
      className={`!tw-text-right ${
        number > 0
          ? "tw-text-success"
          : number < 0
          ? "tw-text-danger"
          : "tw-text-primary-50"
      }`}
    >
      {frontendNumber(number)}
    </div>
  )
}
